export enum ELang {
  'en-GB' = 'en-GB',
  'zh-CN' = 'zh-CN',
  'zh-HK' = 'zh-HK',
}
